export const screen = {
  small: 760,
  medium: 1400,
};

export const HEADER_HEIGHT = 60;
